import * as React from "react";
import { Button } from "../mui";

import "../../styles/components/tablePagination.css";

export default function TablePagination({ 
  currentPage = 1, 
  totalPages = 1,
  onPageChange,
  className = ""
}) {
  const handlePrevious = () => {
    if (currentPage > 1 && onPageChange) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages && onPageChange) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePageClick = (page) => {
    if (onPageChange) {
      onPageChange(page);
    }
  };

  return (
    <div className={`table-pagination ${className}`.trim()}>
      <Button 
        variant="outlined" 
        size="small" 
        className="table-pagination-button" 
        onClick={handlePrevious}
        disabled={currentPage === 1}
      >
        Previous
      </Button>
      
      {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
        <Button
          key={page}
          variant={page === currentPage ? "contained" : "outlined"}
          size="small"
          className={`table-pagination-button ${page === currentPage ? "is-active" : ""}`.trim()}
          onClick={() => handlePageClick(page)}
        >
          {page}
        </Button>
      ))}
      
      <Button 
        variant="outlined" 
        size="small" 
        className="table-pagination-button" 
        onClick={handleNext}
        disabled={currentPage === totalPages}
      >
        Next
      </Button>
    </div>
  );
}
